import React, { useEffect, useRef, useState } from 'react';
import { Container, Form, Button, Row, Col, Card } from 'react-bootstrap';
import './RequestForApproval.css';
import ApprovalProcessService from '../services/ApprovalProcessService';
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";
const RequestForApproval = () => {
  const editorRef = useRef(null);
  const editorInstance = useRef(null);
  const [approvalType, setapprovalType] = useState([]);
  const [companyType, setcompanyType] = useState([]);
  const [requestType, setrequestType] = useState([]);
  const [errors, setErrors] = useState({});
  const { setLoading } = useLoading();
  
  const [formData, setFormData] = useState({
    ApprovalTypeId: '',
    CompanyId: '',
    RequestId: '',
    Description: '',
  });

  const handleChange = (e) => {
    
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  useEffect(() => {
    if (editorRef.current && !editorInstance.current) {
      window.ClassicEditor.create(editorRef.current)
        .then(editor => {
          editorInstance.current = editor;
          // editor.ui.view.editable.element.style.height = '30vh';
        })
        .catch(error => {
          console.error('Error initializing CKEditor:', error);
        });
    }

    const fetchDropdownData = async () => {
      try {
        const approvalTypeResponse = await ApprovalProcessService.getDropDownListData(2);
        const companyhResponse = await ApprovalProcessService.getDropDownListData(1);
        const requestResponse = await ApprovalProcessService.getDropDownListData(3);
        
        if (approvalTypeResponse.success) {
          setapprovalType(approvalTypeResponse.data.result);
        }
        if (companyhResponse.success) {
          setcompanyType(companyhResponse.data.result);
        }
        
        if (requestResponse.success) {
          setrequestType(requestResponse.data.result);
        }
       
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };
    fetchDropdownData();

    return () => {
      if (editorInstance.current) {
        editorInstance.current.destroy();
        editorInstance.current = null;
      }
    };
    
  }, []);

  const handleClear = () => {
    setFormData({
      ApprovalTypeId: '',
    CompanyId: '',
    RequestId: '',
    Description: '',
    });
    if (editorInstance.current) {
      editorInstance.current.setData('');  // Clear CKEditor content
    }
    setErrors({});
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    debugger
    // Capture CKEditor content and update formData before validation
    const descriptionValue = editorInstance.current?.getData().trim() || '';
    setFormData({
      ...formData,
      Description: descriptionValue  // Ensure formData is updated with CKEditor content
    });
  
    // Validate the form after updating formData
    const isValid = validateForm(descriptionValue);
  
    if (isValid) {
      setLoading(true);
      try {
        debugger
        const formDataToSend = new FormData();
        formDataToSend.append('lCType', Number(formData.ApprovalTypeId));
        formDataToSend.append('companyId', Number(formData.CompanyId));
        formDataToSend.append('currentApproverId', Number(formData.RequestId));
        formDataToSend.append('lCDescription', descriptionValue);
        formDataToSend.append('stageId', Number(1));
  
        const response = await ApprovalProcessService.CreateApproval(formDataToSend);
        debugger
        if (response.data.statusCode === 200) {
          setLoading(false);
          handleClear();
          showToast("Data insert successfully.", 'success', { autoClose: 700 });
        } else {
          toast.error('Failed to create ticket. Please try again.');
          setLoading(false);
        }
      } catch (error) {
        toast.error('An error occurred while submitting the form.');
        console.error('Submission Error:', error);
        setLoading(false);
      }
    }
  };
  

  const validateForm = (descriptionValue) => {
    let tempErrors = {};
    let isValid = true;
    // Validate other form fields as before
    Object.keys(formData).forEach((field) => {
      if (field !== 'Description' && !formData[field]) {
        tempErrors[field] = 'This field is required';
        isValid = false;
      }
    });
  
    // Validate CKEditor content (Description)
    const strippedDescription = descriptionValue.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
  
    if (!strippedDescription) {
      tempErrors.Description = 'Description is required';
      isValid = false;
    }
  
    setErrors(tempErrors);
    return isValid;
  };
  
  

  return (
    <Container className="mt-5 request-form">
      <h2 className="page-heading text-left mb-4">Request for Approval</h2>
      <Card className="p-4 shadow-sm">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="ApprovalTypeId">
                <Form.Label>Approval Type</Form.Label>
                <Form.Control
                  as="select"
                  name="ApprovalTypeId"
                  className={`form-select ${errors.ApprovalTypeId ? 'is-invalid' : ''}`}
                  value={formData.ApprovalTypeId}
                  onChange={handleChange}
                >
                  <option value="">Select an Approval</option>
                  {approvalType.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
                </Form.Control>
                {errors.ApprovalTypeId && <div className="invalid-feedback">{errors.ApprovalTypeId}</div>}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="CompanyId">
                <Form.Label>Select an Company</Form.Label>
                <Form.Control
                  as="select"
                  name="CompanyId"
                  className={`form-select ${errors.CompanyId ? 'is-invalid' : ''}`}
                  value={formData.CompanyId}
                  onChange={handleChange}
                >
                  <option value="">Select an Company</option>
                  {companyType.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
                </Form.Control>
                {errors.CompanyId && <div className="invalid-feedback">{errors.CompanyId}</div>}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="RequestId">
                <Form.Label>Select Request To</Form.Label>
                <Form.Control
                  as="select"
                  name="RequestId"
                  className={`form-select ${errors.RequestId ? 'is-invalid' : ''}`}
                  value={formData.RequestId}
                  onChange={handleChange}
                >
                  <option value="">Request To</option>
                  {requestType.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
                </Form.Control>
                {errors.RequestId && <div className="invalid-feedback">{errors.RequestId}</div>}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12}>
              <Form.Group controlId="Description">
                <Form.Label>Description</Form.Label>
                <textarea
                  ref={editorRef}
                  className={`form-control ckeditor ${errors.Description ? 'is-invalid' : ''}`}
                  name="Description"
                  rows={8}
                ></textarea>
                {errors.Description && <div className="invalid-feedback">{errors.Description}</div>}
              </Form.Group>
            </Col>
          </Row>

          <Button variant="primary" type="submit" className="w-100 mt-3">
            Submit
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default RequestForApproval;
